export enum NewsStatus {

    Draft = 1,
    Active = 2,
    Deleted = 3

}
